import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, BoxExtendedProps, LinkButton, Text } from '@common-fe/common-fe';

import { SavedReceiptsTab } from '../../SavedReceiptsPopup.types';

interface Props extends BoxExtendedProps {
  setActiveTab: (tab: SavedReceiptsTab) => void;
}

const ReceiptIsRequiredWarning: React.FC<Props> = ({ setActiveTab, ...props }) => {
  const { t } = useTranslation();

  const handleNavigateToReceipts = useCallback(() => {
    setActiveTab(SavedReceiptsTab.RECEIPTS);
  }, [setActiveTab]);
  
  return (
    <Box
      background="missingContainer"
      pad="spacing16"
      round="container1Round"
      {...props}
    >
      <Text weight={700}>
        {t('A')}
        {' '}
        <LinkButton onClick={handleNavigateToReceipts} linkInlineMode>
          <Text weight={700}>
            {t('receipt')}
          </Text>
        </LinkButton>
        {' '}
        {t('is required to submit claim')}
      </Text>
      <Text margin={{ top: 'spacing2' }}>
        {t('To submit your claim, please go to the Receipts tab and select or upload a proof of purchase.')}
      </Text>
    </Box>
  );
};

export default ReceiptIsRequiredWarning;
